document.addEventListener("DOMContentLoaded", function () {
  var modal = document.getElementById("upsellModal");
  var openModalBtn = document.getElementById("openUpsellModalBtn");
  var closeModalBtn = document.getElementById("closeModalBtn");
  
  // Close the modal if the background is clicked
  window.onclick = function(event) {
      if (event.target == modal) {
          modal.style.display = "none";
      }
  }
});
document.addEventListener("click", function (e) {
  const btn = e.target.closest("#product-add-to-cart, [data-btn-addToCart-upsell]");
  if (!btn) return;

  e.preventDefault();
  console.log("✅ Intercepted Add to Cart click");
  openUpsellModel();
}, true);

// Open the modal
function openUpsellModel() {
  var modal = document.getElementById("upsellModal");
  var openModalBtn = document.getElementById("openUpsellModalBtn");
  var closeModalBtn = document.getElementById("closeModalBtn");
  jQuery.getJSON('/cart.js', function(cart) {
    if(cart){
      let array=cart.items;
      let stringValue="";
      for (var i = 0; i < array.length; ++i) {
        stringValue=stringValue+""+array[i].handle+",";
      }
      $("#upsellsetvalue").val(stringValue);
      let extractValue=$("#upsellsetvalue").val();
      let refer=$("#upsellsetvaluerefer").val();
      if(extractValue !== undefined){
        let array22 = extractValue.split(',');
        if(array22.includes(refer)){
        }else{
          setTimeout(function(){
            $(".hs-popup-cart-sp-load").removeClass("hs-active");
          }, 1500);
          setTimeout(function(){
            modal.style.display = "block";
          }, 2000);
        }
      }    
    }
  });
}
// Open the modal
function closeUpsellModel() {
  var modal = document.getElementById("upsellModal");
  var openModalBtn = document.getElementById("openUpsellModalBtn");
  var closeModalBtn = document.getElementById("closeModalBtn");
  modal.style.display = "none";
  $(".hs-popup-cart-sp-load").addClass("hs-active");
}
function onClickFilter(image) {
  const slides = $(".sliding-items .productView-image");
  const slideArray = [];
  slides.each(function() {
  	slideArray.push({image: $(this).attr("data-attr"), index: $(this).attr("data-index")-1});
  });
  for (let i = 0; i < slideArray.length; i++) {
    if (slideArray[i].image == image) {
      $(".sliding-items").slick('slickGoTo', slideArray[i].index);  
    }
  }
}